<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">
            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>DES Decrypt</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.password"
                               placeholder="Enter Password"/><br/>
                        <textarea class="form-control input-group" style="min-height: 50px;" v-model="values.input" placeholder="Enter DES Encrypted Data"></textarea>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <textarea class="form-control input-group" style="min-height: 131px;" v-model="values.output" placeholder="DES Decrypted Data Result"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear Data
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy Result
                    </button>
                </div>
            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>

                    <div v-if="!this.$root.mobile" class="card shadow mt-4 pl-2 pt-2 pb-2 pr-2 bg-gradient-neutral">
                        <h1>DES</h1>
                        <p>
                            The Data Encryption Standard is a symmetric-key algorithm for the
                            encryption of electronic data. Although its short key length of 56 bits, criticized from the
                            beginning, makes it too insecure for most current applications, it was highly influential in
                            the advancement of modern cryptography.

                            Developed in the early 1970s at IBM and based on an earlier design by Horst Feistel, the
                            algorithm was submitted to the National Bureau of Standards (NBS) following the agency's
                            invitation to propose a candidate for the protection of sensitive, unclassified electronic
                            government data. In 1976, after consultation with the National Security Agency (NSA), the
                            NBS eventually selected a slightly modified version (strengthened against differential
                            cryptanalysis, but weakened against brute-force attacks), which was published as an official
                            Federal Information Processing Standard (FIPS) for the United States in 1977.
                        </p>
                    </div>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'

    Vue.use(VueClipboard);
    import CryptoJS from 'crypto-js';

    export default {
        name: "AesDecode",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                values: {
                    password: null,
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.password = null;
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input && this.values.password) {
                    let bytes  = CryptoJS.DES.decrypt(this.values.input.toString(), this.values.password);
                    let plaintext = bytes.toString(CryptoJS.enc.Utf8);

                    this.values.output = plaintext;
                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "des",
                        output: this.values.output,
                        outType: "text",
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
